/**
 * Scroll-reveal for elements marked `.reveal`, matching
 * spanishsecrets-website's behavior: fade + slide up as each element
 * enters the viewport, skipped entirely for prefers-reduced-motion.
 *
 * One change from that implementation: elements are visible by default
 * and only hidden once `.js-reveal-ready` is added below, right before
 * observing them. If this script fails to load or throws, content never
 * gets stuck invisible -- the live site's version has no such fallback,
 * so a JS failure there means the `.reveal` elements stay at their CSS
 * opacity: 0 forever.
 */
(function () {
  var revealEls = document.querySelectorAll('.reveal');
  if (!revealEls.length) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }

  document.documentElement.classList.add('js-reveal-ready');

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  revealEls.forEach(function (el) { observer.observe(el); });
})();
